import { inheritActionOwner, isActionCurrent } from '@/_core/fluxstore/dispatchOwnership';
import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createNewCardCommand } from '../../../api/commands/factory/createNewCard';
import { StorymapState, Task } from '../../types';
import { getCardById } from '../../use';
import { useStorymapStore } from '../../useModule';
import { FlashJustDragged } from '../moveCard/flashJustDragged';
import { AddNewCardResult } from '../../../api/commands';
import { SetKeyOnNewCard } from './setKeyOnNewCard';
import { createDebugger } from '@/_core/utils/debug';

const debug = createDebugger('pages:main:storymap:store:actions:newCard:saveNewTask');

const { registerReducer, registerMiddleware, dispatch } = useStorymapStore();

export class SaveNewTask extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'SaveNewTask';

    public _savedCard: Task = null;
    public constructor(public cardId: string, public title: string) {
        super(SaveNewTask.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SaveNewTask): Promise<boolean> => {
    debug('SaveNewTask.middleware start', action);

    const card = getCardById(action.cardId);
    if (card) {
        card.isSaving = true;
    }

    if (!action.isDispatchedByRealTimeCallback) {
        dispatch(inheritActionOwner(action, new FlashJustDragged()));
    }

    const command = action.isDispatchedByRealTimeCallback ? null : await createNewCardCommand(action);
    if (!isActionCurrent(action)) return false;
    await useSendCommandAsync(action, {
        isCurrent: () => isActionCurrent(action),
        createCommand: async () => command,
        onSuccess: (res: AddNewCardResult) => {
            if (!isActionCurrent(action)) return;
            dispatch(inheritActionOwner(action, new SetKeyOnNewCard(action.cardId, res.CardKey)));
        },
    });

    if (!isActionCurrent(action)) return false;
    if (!action.isDispatchedByRealTimeCallback) {
        action._savedCard = getCardById(action.cardId) as Task;
    }

    debug('SaveNewTask.middleware end', action);

    return true;
};

const reducer = (state: StorymapState, action: SaveNewTask): void => {
    if (action.isDispatchedByRealTimeCallback) {
        state.tasks
            .filter((x) => x.activityId == action._savedCard.activityId && x.order >= action._savedCard.order)
            .forEach((x) => x.order++);

        state.tasks.push(action._savedCard);
    }

    const card = getCardById(action.cardId);
    card.title = action.title;
    card.color = state.taskColor;
    card.isNew = false;
    card.isSaving = false;

    if (action.isDispatchedByRealTimeCallback) {
        card.isActive = false;
    }

    return;
};

//@ts-ignore
registerMiddleware(SaveNewTask.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SaveNewTask.ACTION_TYPE, reducer);
